import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Paper, Typography, WithStyles } from "@material-ui/core";
import { styles } from "./ManageUsersFilter.styles";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import Grid from "@material-ui/core/Grid/Grid";

const userTypes = ["Internal", "External"];
const activeFilters = ["Active", "Inactive"];
const lockedFilters = ["Not locked", "Locked"];

export interface IManageUsersFilterProps extends WithStyles<typeof styles> {
    userTypesChecked: string[];
    onUserTypeCheckboxClick: (event: React.MouseEvent<HTMLElement>, newTypes: string[]) => void;
    activeChecked: string[];
    onActiveCheckboxClick: (event: React.MouseEvent<HTMLElement>, newActive: string[]) => void;
    lockedChecked: string[];
    onLockedCheckboxClick: (event: React.MouseEvent<HTMLElement>, newLocked: string[]) => void;
}

const ManageUsersFilterPure: React.FunctionComponent<IManageUsersFilterProps> = ({
    classes,
    userTypesChecked,
    onUserTypeCheckboxClick,
    activeChecked,
    onActiveCheckboxClick,
    lockedChecked,
    onLockedCheckboxClick
}: IManageUsersFilterProps) => {
    return (
        <Paper variant="outlined" className={classes.paper}>
            <Grid container spacing={3}>
                <Grid xs={4} item>
                    <Typography variant="h6">User type</Typography>
                    <div className={classes.sectionInput}>
                        <ToggleButtonGroup
                            value={userTypesChecked}
                            onChange={onUserTypeCheckboxClick}
                            aria-label="text formatting"
                            className={classes.buttonGroup}
                        >
                            {userTypes.map(userType => (
                                <ToggleButton
                                    key={userType}
                                    value={userType}
                                    aria-label="bold"
                                    className={classes.toggleButton}
                                >
                                    {userType}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                </Grid>
                <Grid xs={4} item>
                    <Typography variant="h6">Active</Typography>
                    <div className={classes.sectionInput}>
                        <ToggleButtonGroup
                            value={activeChecked}
                            onChange={onActiveCheckboxClick}
                            aria-label="text formatting"
                            className={classes.buttonGroup}
                        >
                            {activeFilters.map(activeFilter => (
                                <ToggleButton
                                    key={activeFilter}
                                    value={activeFilter}
                                    aria-label="bold"
                                    className={classes.toggleButton}
                                >
                                    {activeFilter}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                </Grid>
                <Grid xs={4} item>
                    <Typography variant="h6">Locked</Typography>
                    <div className={classes.sectionInput}>
                        <ToggleButtonGroup
                            value={lockedChecked}
                            onChange={onLockedCheckboxClick}
                            aria-label="text formatting"
                            className={classes.buttonGroup}
                        >
                            {lockedFilters.map(lockedFilter => (
                                <ToggleButton
                                    key={lockedFilter}
                                    value={lockedFilter}
                                    aria-label="bold"
                                    className={classes.toggleButton}
                                >
                                    {lockedFilter}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                </Grid>
            </Grid>
        </Paper>
    );
};

export const ManageUsersFilter = withStyles(styles)(ManageUsersFilterPure);
